import { ethers } from 'ethers';
import { customChainToAddMetamask, customChain } from '../../constants';

export const checkAndAddChain = async () => {
  if (typeof (window as any)?.ethereum !== 'undefined') {
    const provider = new ethers.providers.Web3Provider(
      (window as any).ethereum,
    );
    const { chainId } = await provider.getNetwork();

    if (chainId !== customChain.id) {
      try {
        await (window as any).ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [customChainToAddMetamask],
        });
        console.log('Chain added successfully');
      } catch (error) {
        console.error('Error adding chain:', error);
      }
    } else {
      console.log('Chain already exists');
    }
  } else {
    console.error('MetaMask is not installed');
  }
};
